import { Controller } from 'stimulus';
import WatchlistButton from '../data_services/preact-components/WatchlistButton';
import { h, render } from 'preact';
import Utility from 'classes/Utility';
import MitreTable from '../utils/mitre-table';

export default class extends Controller {
  static targets = [
    'cell',
    'toggleWatchlistButton'
  ]

  initialize() {
    const tableKey = this.element.getAttribute('data-table-key');
    this._mitreTable = MitreTable.getByTableKey(tableKey);
  }

  async connect() {
    this.__resizeCells(this.__getCells());
    await this.__fetchMembership();
    this.__addWatchlistButton();

    this._mitreTable.on('table-sponsor-row-update-complete', () => {
      this.__resizeCells(this.__getCells());
      this.__resizeContainerWidth();
      this.__addWatchlistButton();
    });
  }

  __getCells = () => {
    if (this.hasCellTarget) {
      return this.cellTargets;
    }
    return this.element.querySelectorAll('[data-table-target*="cell"]');
  }

  __resizeContainerWidth() {
    const containers = this.element.querySelectorAll('.m-table-scrollable-row-container');
    if (containers.length > 0) {
      containers.forEach(container => {
        container.classList.add('t-w-full');
      })
    }
  }

  __fetchMembership = async () => {
    try {
      const response = await Utility.getConfigData({
        type: 'current_user'
      });
      const { premium } = response.data;
      this.isPremium = premium;
    } catch (e) {
      this.isPremium = false;
    }
  }

  __resizeCells(elements) {
    elements.forEach(el => {
      el.style.width = el.getAttribute('data-cell-dimension');
    })
  }

  __addWatchlistButton() {
    if (this.hasToggleWatchlistButtonTarget) {
      this.toggleWatchlistButtonTargets.forEach(el => {
        try {
          const symbol = el.getAttribute('data-simple-table-watchlist-symbol');
          const securityType = el.getAttribute('data-simple-table-watchlist-security_type');
          el.parentNode.classList.add('t-text-transparent');
          render(<WatchlistButton state={el.getAttribute('data-watchlist-state')} isPremium={this.isPremium} symbol={symbol} securityType={securityType} type="searchCenter" />, el.parentNode, el);
        } catch(e) {
          console.log(e)
        }
      })
    }
  }
}

